import config from "../../config";

export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function getToken() {
  const token = `${getCookie("access")}`;
  return token;
}

export function concatPathWithParams(path, queryParams) {
  let pathWithParams = path;
  if (queryParams && Object.keys(queryParams).length) {
    pathWithParams += `?${_queryParamsToQueryString(queryParams)}`;
  }
  return pathWithParams;
}

function _queryParamsToQueryString(queryParams) {
  return Object.keys(queryParams)
    .filter((key) => queryParams[key] !== undefined)
    .map((key) => `${key}=${encodeURIComponent(queryParams[key])}`)
    .join("&");
}

export const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};

export function setCookie(token) {
  // A login replaces the session rather than merging into it — see clearCookie. Without this,
  // signing in here after another user kept their `${group}=true` cookies, which IMS reads for
  // its permission checks on the same domain.
  clearCookie();

  let manager = parseJwt(token.access).Manager;
  let developer = parseJwt(token.access).Developer;
  document.cookie = `refresh=${token.refresh};max-age=86400;domain=${config.REACT_APP_SECRET_DOMAIN};path=/`;
  document.cookie = `access=${token.access};max-age=57600;domain=${config.REACT_APP_SECRET_DOMAIN};path=/`;
  if (manager) {
    document.cookie = `manager=${manager};max-age=57600;domain=${config.REACT_APP_SECRET_DOMAIN};path=/`;
  }
  if (developer) {
    document.cookie = `developer=${developer};max-age=57600;domain=${config.REACT_APP_SECRET_DOMAIN};path=/`;
  }
}
export function clearCookie() {
  // Named four cookies and missed every `${group}=true` one Userport writes, so signing out of
  // Field Admin left, e.g., a previous admin's `global_super_user=true` behind for the next user
  // on this browser. Clear the whole jar instead of a list — group names come from the server,
  // so a hardcoded list would silently miss the next one added. Same approach as IMS/Userport.
  const domain = config.REACT_APP_SECRET_DOMAIN;
  const domainAttr = domain && domain !== "undefined" ? `domain=${domain};` : "";
  const EXPIRED = "expires=Thu, 01 Jan 1970 00:00:00 UTC";

  for (const cookie of document.cookie.split(";")) {
    const eqPos = cookie.indexOf("=");
    const name = (eqPos > -1 ? cookie.substring(0, eqPos) : cookie).trim();
    if (!name) continue;
    // Both variants: this app writes with a domain attribute, but Userport's cookies on the
    // same host are host-only, and against a real domain those are two distinct cookies that
    // can share a name. Expiring one form would leave the other readable.
    document.cookie = `${name}=;${EXPIRED};path=/`;
    if (domainAttr) document.cookie = `${name}=;${EXPIRED};${domainAttr}path=/`;
  }
}
